export enum WithdrawLodgedDocumentStepsEnum {
  FormDetails = 0,
  DocumentDetails = 1,
  AmendmentDetails = 2,
  // DocumentBeingAmended = 3,
}

